export const MY_ORDERS = '/my-orders';
export const MY_ARCHIVES = '/my-archives';
export const MY_ORDERS_DETAILS = '/my-orders/details/:id';
